// extracted by mini-css-extract-plugin
module.exports = {"button":"_1xBpMsT2OybsnU3Au9Pp"};